/**
 * Product Card Mobile Animation
 * Triggers the secondary image transition on mobile when the card enters the viewport.
 */
(() => {
  const initMobileAnimation = () => {
    const productCards = document.querySelectorAll('.product-card-wrapper[data-mobile-animation]');
    if (productCards.length === 0) return;

    const isMobile = window.matchMedia('(max-width: 989px)');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const card = entry.target;
        const animationType = card.getAttribute('data-mobile-animation');

        if (entry.isIntersecting && isMobile.matches) {
          if (animationType === 'once') {
            if (!card.dataset.animated) {
              triggerOnce(card);
              card.dataset.animated = 'true';
            }
          } else if (animationType === 'infinite') {
            triggerInfinite(card);
          }
        } else {
          if (animationType === 'infinite') {
            stopInfinite(card);
          }
        }
      });
    }, {
      threshold: 0.6
    });

    productCards.forEach((card) => observer.observe(card));

    function triggerOnce(card) {
      setTimeout(() => {
        card.classList.add('is-active');
        setTimeout(() => {
          card.classList.remove('is-active');
        }, 2000);
      }, 500);
    }

    function triggerInfinite(card) {
      if (card.dataset.infiniteInterval) return;
      
      const intervalTime = 4000;
      const duration = 2000;

      const runAnimation = () => {
        card.classList.add('is-active');
        const timeoutId = setTimeout(() => {
          card.classList.remove('is-active');
        }, duration);
        card.dataset.timeoutId = timeoutId;
      };

      runAnimation();
      const intervalId = setInterval(runAnimation, intervalTime);
      card.dataset.infiniteInterval = intervalId;
    }

    function stopInfinite(card) {
      if (card.dataset.infiniteInterval) {
        clearInterval(parseInt(card.dataset.infiniteInterval));
        delete card.dataset.infiniteInterval;
      }
      if (card.dataset.timeoutId) {
        clearTimeout(parseInt(card.dataset.timeoutId));
        delete card.dataset.timeoutId;
      }
      card.classList.remove('is-active');
    }
  };

  document.addEventListener('DOMContentLoaded', initMobileAnimation);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initMobileAnimation);
  }
})();
